import { Get, Post, Put } from "utils/api.utils";
import ApiPath from "enums/api-path";

export const getPriceBuildUps = async (query) => {
  const res = await Get(`${ApiPath.PriceBuildUp}`, { ...query });
  // useDataTable expects { [key]: [], count }
  return { priceBuildUps: res.data || [], count: res.count ?? 0 };
};

export const getStationByCode = async ({ stationCode }) => {
  const url = ApiPath.GetStationPricing.replace(":stationCode", stationCode);
  const res = await Get(url);
  return res.data;
};

export const getDepots = async (params) => {
  const res = await Get(ApiPath.Depot, params);
  return res.data;
};

export const getStationsPricing = async (params) => {
  const res = await Get(ApiPath.GetStationsPricing, params);
  return res.data;
};

export const getPriceBuildUp = async ({ priceBuildUpId }) => {
  const res = await Get(`${ApiPath.PriceBuildUp}/${priceBuildUpId}`);
  return res.data;
};

export const createPriceBuildUp = async (body) => {
  const res = await Post(`${ApiPath.PriceBuildUp}`, body);
  return res.data;
};

export const updatePriceBuildUp = async ({ priceBuildUpId, ...body }) => {
  const res = await Put(`${ApiPath.PriceBuildUp}/${priceBuildUpId}`, body);
  return res.data;
};

export const cancelPriceBuildUp = async ({ priceBuildUpId, remarks }) => {
  const res = await Put(`${ApiPath.PriceBuildUp}/${priceBuildUpId}/cancel`, remarks ? { remarks } : undefined);
  return res.data;
};
